<script lang="ts">

  import BanknoteIcon from "@lucide/svelte/icons/banknote"
  import BookUserIcon from "@lucide/svelte/icons/book-user"
  import CalendarFoldIcon from "@lucide/svelte/icons/calendar-fold"
  import CircleHelpIcon from "@lucide/svelte/icons/circle-help"
  import ClipboardPenLineIcon from "@lucide/svelte/icons/clipboard-pen-line"
  import FileUserIcon from "@lucide/svelte/icons/file-user"
  import InfoIcon from "@lucide/svelte/icons/info"
  import MessageSquareQuoteIcon from "@lucide/svelte/icons/message-square-quote"
  import MenuItem from "../../_components/menu-item.svelte"

  let { prefix }: { prefix: string } = $props()
  const items = [
    { path: "faq", label: "FAQ", icon: CircleHelpIcon, compact: false },
    { path: "info", label: "Info", icon: InfoIcon },
    { path: "memo", label: "Memo", icon: MessageSquareQuoteIcon },
    { path: "event", label: "Event", icon: CalendarFoldIcon },
    { path: "order", label: "Order", icon: ClipboardPenLineIcon },
    { path: "order-outstanding", label: "Outstanding", icon: BanknoteIcon },
    { path: "customer", label: "Customer", icon: BookUserIcon },
    { path: "customer-noo", label: "NOO", icon: FileUserIcon },
  ]

</script>

<div class="mx-3">
  <div class="grid grid-cols-4 justify-items-stretch gap-4">
    {#each items as item (item.path)}
      <MenuItem
        prefix={prefix}
        {...item}/>
    {/each}
  </div>
</div>
